import { render, staticRenderFns } from "./QuoteDetailSummary.vue?vue&type=template&id=80198e8e&scoped=true"
import script from "./QuoteDetailSummary.vue?vue&type=script&lang=js"
export * from "./QuoteDetailSummary.vue?vue&type=script&lang=js"
import style0 from "./QuoteDetailSummary.vue?vue&type=style&index=0&id=80198e8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80198e8e",
  null
  
)

export default component.exports